import type { LocaleMessageBundle } from '../../types'

export const shiftClosingReportMessages: LocaleMessageBundle = {
  vi: {
    'shiftClosingReport.aggregate.compareTitle': 'Đối chiếu bàn giao ca',
    'shiftClosingReport.aggregate.compareHint':
      'Kiểm tra đồng thời số liệu của ca bàn giao và số liệu lũy kế toàn chuỗi trước khi tiếp nhận.',
    'shiftClosingReport.aggregate.singleReport': 'Phiếu ca đơn lẻ',
    'shiftClosingReport.aggregate.cumulativeReport': 'Phiếu gộp lũy kế',
    'shiftClosingReport.aggregate.shiftCount': '{count} ca',
    'shiftClosingReport.aggregate.retry': 'Thử tải lại phiếu gộp',
    'shiftClosingReport.aggregate.sectionTitle': 'Phiếu gộp bàn giao',
    'shiftClosingReport.aggregate.sourceCount': 'Số ca nguồn',
    'shiftClosingReport.aggregate.period': 'Khoảng thời gian',
    'shiftClosingReport.aggregate.status.current': 'Hiện hành',
    'shiftClosingReport.aggregate.status.superseded': 'Đã có bản mới',
    'shiftClosingReport.aggregate.status.stale': 'Cần tạo lại',
    'shiftClosingReport.aggregate.availability.not_created': 'Chưa có dữ liệu lũy kế từ ca trước.',
    'shiftClosingReport.aggregate.availability.generating': 'Phiếu gộp đang được tạo.',
    'shiftClosingReport.aggregate.availability.stale':
      'Phiếu gộp không còn hiện hành vì một phiếu nguồn đã thay đổi.',
    'shiftClosingReport.aggregate.availability.unavailable': 'Không thể tải phiếu gộp lúc này.',
    'shiftClosingReport.notification.title': 'Phiếu bàn giao đang chờ',
    'shiftClosingReport.notification.detailTitle': 'Chi tiết phiếu bàn giao',
    'shiftClosingReport.notification.message':
      'Bạn có phiếu bàn giao từ {staff}. Vui lòng kiểm tra và tiếp nhận.',
    'shiftClosingReport.notification.remaining': 'Có {count} phiếu đang chờ tiếp nhận',
    'shiftClosingReport.notification.cashReceived': 'Tiền mặt được bàn giao',
    'shiftClosingReport.notification.later': 'Để sau',
    'shiftClosingReport.actions.viewDetail': 'Xem chi tiết',
    'shiftClosingReport.actions.acceptHandover': 'Tiếp nhận bàn giao',
    'shiftClosingReport.sections.handoverRequests': 'Yêu cầu tiếp nhận bàn giao',
    'shiftClosingReport.sections.handoverRequestsHint':
      'Các báo cáo chốt ca được bàn giao cho bạn trong khoảng thời gian đang chọn.',
    'shiftClosingReport.fields.handoverFrom': 'Người bàn giao',
    'shiftClosingReport.fields.handoverAcceptedAt': 'Thời gian tiếp nhận',
    'shiftClosingReport.table.handoverStatus': 'Trạng thái bàn giao',
    'shiftClosingReport.handoverStatus.pending': 'Chờ tiếp nhận',
    'shiftClosingReport.handoverStatus.accepted': 'Đã tiếp nhận',
    'shiftClosingReport.title': 'Báo cáo chốt ca',
    'shiftClosingReport.filters.branch': 'Chi nhánh',
    'shiftClosingReport.filters.staff': 'Nhân viên',
    'shiftClosingReport.filters.status': 'Trạng thái',
    'shiftClosingReport.filters.all': 'Tất cả',
    'shiftClosingReport.actions.view': 'Xem báo cáo',
    'shiftClosingReport.actions.export': 'Xuất Excel',
    'shiftClosingReport.actions.prepareSubmit': 'Chốt ca của tôi',
    'shiftClosingReport.actions.createReport': 'Lập báo cáo',
    'shiftClosingReport.actions.submit': 'Gửi báo cáo chốt ca',
    'shiftClosingReport.actions.update': 'Cập nhật báo cáo chốt ca',
    'shiftClosingReport.actions.approve': 'Duyệt',
    'shiftClosingReport.actions.reject': 'Từ chối',
    'shiftClosingReport.actions.cancel': 'Đóng',
    'shiftClosingReport.actions.confirmReject': 'Xác nhận từ chối',
    'shiftClosingReport.actions.addRow': 'Thêm dòng',
    'shiftClosingReport.stats.invoiceCount': 'Tổng số hóa đơn',
    'shiftClosingReport.stats.revenue': 'Tổng doanh thu',
    'shiftClosingReport.stats.goods': 'Tổng tiền hàng',
    'shiftClosingReport.stats.time': 'Tổng tiền giờ',
    'shiftClosingReport.stats.discount': 'Tổng giảm giá',
    'shiftClosingReport.stats.vat': 'Tổng thuế/VAT',
    'shiftClosingReport.stats.receipt': 'Tổng phiếu thu',
    'shiftClosingReport.stats.payment': 'Tổng phiếu chi',
    'shiftClosingReport.stats.net': 'Chênh lệch thu chi',
    'shiftClosingReport.stats.actualRevenue': 'Thực thu theo hệ thống',
    'shiftClosingReport.stats.debt': 'Công nợ phát sinh',
    'shiftClosingReport.stats.actualTotal': 'Tổng tiền thực tế',
    'shiftClosingReport.stats.formulaTitle': 'Công thức tính',
    'shiftClosingReport.stats.formula.invoiceCount':
      'Tổng số hóa đơn = Số hóa đơn hoàn thành trong ca',
    'shiftClosingReport.stats.formula.revenue':
      'Tổng doanh thu = Tiền thu khi chốt hóa đơn + Công nợ ghi trên hóa đơn (không tính tiền thu nợ)',
    'shiftClosingReport.stats.formula.goods':
      'Tổng tiền hàng = Tiền hàng trên hóa đơn (không tính tiền giờ bàn)',
    'shiftClosingReport.stats.formula.time': 'Tổng tiền giờ = Tiền giờ bàn trên hóa đơn',
    'shiftClosingReport.stats.formula.discount':
      'Tổng giảm giá = Tổng tiền giảm trên các hóa đơn + Giá trị điểm đã sử dụng',
    'shiftClosingReport.stats.formula.vat': 'Tổng thuế/VAT = Tổng thuế VAT trên các hóa đơn',
    'shiftClosingReport.stats.formula.receipt':
      'Tổng phiếu thu = Tổng tiền trong các phiếu thu của ca',
    'shiftClosingReport.stats.formula.payment':
      'Tổng phiếu chi = Tổng tiền trong các phiếu chi của ca',
    'shiftClosingReport.stats.formula.actualRevenue':
      'Thực thu theo hệ thống = Tổng doanh thu + Tiền phiếu thu ảnh hưởng lợi nhuận - Tiền phiếu chi ảnh hưởng lợi nhuận',
    'shiftClosingReport.stats.formula.debt':
      'Công nợ phát sinh = Công nợ trên hóa đơn - Tiền thu nợ trong ca (không nhỏ hơn 0)',
    'shiftClosingReport.sections.reconciliation': 'Đối chiếu tiền thực tế',
    'shiftClosingReport.sections.saved': 'Báo cáo đã gửi',
    'shiftClosingReport.sections.invoices': 'Hóa đơn',
    'shiftClosingReport.sections.debtInvoices': 'Hóa đơn nợ',
    'shiftClosingReport.sections.receipts': 'Phiếu thu',
    'shiftClosingReport.sections.payments': 'Phiếu chi',
    'shiftClosingReport.sections.paymentMethods': 'Theo phương thức thanh toán',
    'shiftClosingReport.sections.paymentMethodsHint': 'Tổng tiền đã thu theo từng phương thức',
    'shiftClosingReport.sections.revenueOverview': 'Tổng quan doanh thu',
    'shiftClosingReport.sections.systemDetails': 'Chi tiết theo hệ thống',
    'shiftClosingReport.fields.systemCash': 'Tiền mặt theo hệ thống',
    'shiftClosingReport.fields.actualCash': 'Tiền mặt thực tế',
    'shiftClosingReport.fields.cashDifference': 'Chênh lệch tiền mặt',
    'shiftClosingReport.fields.systemTransfer': 'Chuyển khoản theo hệ thống',
    'shiftClosingReport.fields.actualTransfer': 'Chuyển khoản thực tế',
    'shiftClosingReport.fields.transferDifference': 'Chênh lệch chuyển khoản',
    'shiftClosingReport.fields.note': 'Ghi chú/giải trình',
    'shiftClosingReport.fields.reason': 'Lý do',
    'shiftClosingReport.fields.startedAt': 'Giờ bắt đầu',
    'shiftClosingReport.fields.endedAt': 'Giờ kết thúc',
    'shiftClosingReport.fields.receptionist': 'Lễ tân phụ trách',
    'shiftClosingReport.fields.handoverTo': 'Người nhận bàn giao',
    'shiftClosingReport.fields.customer': 'Khách hàng',
    'shiftClosingReport.fields.debtReason': 'Lý do ghi nợ',
    'shiftClosingReport.fields.confirmer': 'Người xác nhận',
    'shiftClosingReport.fields.product': 'Mặt hàng',
    'shiftClosingReport.fields.openingQuantity': 'SL đầu ca',
    'shiftClosingReport.fields.closingQuantity': 'SL cuối ca',
    'shiftClosingReport.fields.playingTables': 'Bàn đang chơi',
    'shiftClosingReport.fields.pendingTasks': 'Nội dung chưa hoàn thành',
    'shiftClosingReport.form.shiftInfo': 'Thông tin ca',
    'shiftClosingReport.form.revenue': 'Doanh thu',
    'shiftClosingReport.form.payments': 'Thanh toán',
    'shiftClosingReport.form.cash': 'Tiền mặt',
    'shiftClosingReport.form.debts': 'Công nợ',
    'shiftClosingReport.form.expenses': 'Chi phí trong ca',
    'shiftClosingReport.form.inventory': 'Tồn kho nhanh',
    'shiftClosingReport.form.handover': 'Bàn giao',
    'shiftClosingReport.form.systemValue': 'Giá trị hệ thống',
    'shiftClosingReport.form.actualValue': 'Giá trị thực tế',
    'shiftClosingReport.form.differenceValue': 'Giá trị chênh lệch',
    'shiftClosingReport.paymentBreakdown.show': 'Xem chi tiết dòng tiền',
    'shiftClosingReport.paymentBreakdown.hide': 'Ẩn chi tiết dòng tiền',
    'shiftClosingReport.paymentBreakdown.sales': 'Bán hàng và thu công nợ',
    'shiftClosingReport.paymentBreakdown.receipts': 'Phiếu thu',
    'shiftClosingReport.paymentBreakdown.payments': 'Phiếu chi',
    'shiftClosingReport.paymentBreakdown.net': 'Số ròng',
    'shiftClosingReport.metrics.sales': 'Tổng doanh thu',
    'shiftClosingReport.metrics.cash': 'Tiền mặt',
    'shiftClosingReport.metrics.transfer_qr': 'Chuyển khoản/QR',
    'shiftClosingReport.metrics.card': 'Thẻ',
    'shiftClosingReport.metrics.e_wallet': 'Ví điện tử',
    'shiftClosingReport.metrics.debt': 'Công nợ/ghi nợ',
    'shiftClosingReport.metrics.opening': 'Tiền đầu ca',
    'shiftClosingReport.metrics.cash_sales': 'Doanh thu tiền mặt',
    'shiftClosingReport.metrics.shift_receipts': 'Thu trong ca',
    'shiftClosingReport.metrics.expenses': 'Chi trong ca',
    'shiftClosingReport.metrics.closing': 'Tiền cuối ca',
    'shiftClosingReport.metrics.theoretical_closing': 'Tiền lý thuyết cuối ca',
    'shiftClosingReport.metrics.counted': 'Tiền thực tế kiểm đếm',
    'shiftClosingReport.metrics.difference': 'Chênh lệch',
    'shiftClosingReport.table.code': 'Mã',
    'shiftClosingReport.table.date': 'Ngày',
    'shiftClosingReport.table.time': 'Thời gian',
    'shiftClosingReport.table.customer': 'Khách hàng/Đối tượng',
    'shiftClosingReport.table.staff': 'Nhân viên',
    'shiftClosingReport.table.type': 'Loại',
    'shiftClosingReport.table.paymentMethod': 'PTTT',
    'shiftClosingReport.table.goods': 'Tiền hàng',
    'shiftClosingReport.table.timeAmount': 'Tiền giờ',
    'shiftClosingReport.table.discount': 'Giảm giá',
    'shiftClosingReport.table.vat': 'Thuế/VAT',
    'shiftClosingReport.table.amount': 'Số tiền',
    'shiftClosingReport.table.total': 'Tổng tiền',
    'shiftClosingReport.table.paidAmount': 'Đã thanh toán',
    'shiftClosingReport.table.debtAmount': 'Còn nợ',
    'shiftClosingReport.table.status': 'Trạng thái',
    'shiftClosingReport.table.actions': 'Thao tác',
    'shiftClosingReport.table.shift': 'Ca',
    'shiftClosingReport.table.approver': 'Người duyệt',
    'shiftClosingReport.table.approvedAt': 'Thời gian duyệt',
    'shiftClosingReport.table.rejector': 'Người từ chối',
    'shiftClosingReport.table.rejectedAt': 'Thời gian từ chối',
    'shiftClosingReport.table.content': 'Nội dung',
    'shiftClosingReport.table.money': 'Số tiền (₫)',
    'shiftClosingReport.status.draft': 'Chưa chốt',
    'shiftClosingReport.status.submitted': 'Đã gửi',
    'shiftClosingReport.status.approved': 'Đã duyệt',
    'shiftClosingReport.status.rejected': 'Từ chối',
    'shiftClosingReport.status.reopened': 'Đã mở lại',
    'shiftClosingReport.warning.difference':
      'Số tiền thực tế đang chênh lệch với hệ thống. Vui lòng nhập giải trình trước khi gửi.',
    'shiftClosingReport.validation.noteRequired': 'Cần nhập giải trình khi có chênh lệch.',
    'shiftClosingReport.validation.reasonRequired': 'Vui lòng nhập lý do từ chối.',
    'shiftClosingReport.messages.submitted': 'Đã gửi báo cáo chốt ca.',
    'shiftClosingReport.messages.approved': 'Đã duyệt báo cáo.',
    'shiftClosingReport.messages.rejected': 'Đã từ chối báo cáo.',
    'shiftClosingReport.errors.load': 'Không thể tải báo cáo chốt ca.',
    'shiftClosingReport.empty': 'Không có dữ liệu trong khoảng thời gian này.',
    'shiftClosingReport.payments.cash': 'Tiền mặt',
    'shiftClosingReport.payments.card': 'Thẻ',
    'shiftClosingReport.payments.transfer': 'Chuyển khoản',
    'shiftClosingReport.payments.bank_transfer': 'Chuyển khoản',
    'shiftClosingReport.payments.transfer_qr': 'Chuyển khoản/QR',
    'shiftClosingReport.payments.qr': 'Mã QR',
    'shiftClosingReport.payments.e_wallet': 'Ví điện tử',
    'shiftClosingReport.payments.wallet': 'Ví điện tử',
    'shiftClosingReport.payments.other': 'Khác',
  },
  en: {
    'shiftClosingReport.aggregate.compareTitle': 'Shift handover comparison',
    'shiftClosingReport.aggregate.compareHint':
      'Review the handed-over shift and the cumulative chain side by side before accepting.',
    'shiftClosingReport.aggregate.singleReport': 'Individual shift report',
    'shiftClosingReport.aggregate.cumulativeReport': 'Cumulative report',
    'shiftClosingReport.aggregate.shiftCount': '{count} shifts',
    'shiftClosingReport.aggregate.retry': 'Retry cumulative report',
    'shiftClosingReport.aggregate.sectionTitle': 'Handover aggregates',
    'shiftClosingReport.aggregate.sourceCount': 'Source shifts',
    'shiftClosingReport.aggregate.period': 'Period',
    'shiftClosingReport.aggregate.status.current': 'Current',
    'shiftClosingReport.aggregate.status.superseded': 'Superseded',
    'shiftClosingReport.aggregate.status.stale': 'Needs regeneration',
    'shiftClosingReport.aggregate.availability.not_created':
      'No cumulative data is available from a previous shift.',
    'shiftClosingReport.aggregate.availability.generating':
      'The cumulative report is being generated.',
    'shiftClosingReport.aggregate.availability.stale':
      'The cumulative report is outdated because a source report changed.',
    'shiftClosingReport.aggregate.availability.unavailable':
      'The cumulative report is unavailable right now.',
    'shiftClosingReport.notification.title': 'Pending handover',
    'shiftClosingReport.notification.detailTitle': 'Handover details',
    'shiftClosingReport.notification.message':
      'You have a handover from {staff}. Please review and accept it.',
    'shiftClosingReport.notification.remaining': '{count} handovers are pending',
    'shiftClosingReport.notification.cashReceived': 'Cash handed over',
    'shiftClosingReport.notification.later': 'Later',
    'shiftClosingReport.actions.viewDetail': 'View details',
    'shiftClosingReport.actions.acceptHandover': 'Accept handover',
    'shiftClosingReport.sections.handoverRequests': 'Handover requests',
    'shiftClosingReport.sections.handoverRequestsHint':
      'Shift reports handed over to you in the selected date range.',
    'shiftClosingReport.fields.handoverFrom': 'Handed over by',
    'shiftClosingReport.fields.handoverAcceptedAt': 'Accepted at',
    'shiftClosingReport.table.handoverStatus': 'Handover status',
    'shiftClosingReport.handoverStatus.pending': 'Pending acceptance',
    'shiftClosingReport.handoverStatus.accepted': 'Accepted',
    'shiftClosingReport.title': 'Shift closing report',
    'shiftClosingReport.filters.branch': 'Branch',
    'shiftClosingReport.filters.staff': 'Staff',
    'shiftClosingReport.filters.status': 'Status',
    'shiftClosingReport.filters.all': 'All',
    'shiftClosingReport.actions.view': 'View report',
    'shiftClosingReport.actions.export': 'Export Excel',
    'shiftClosingReport.actions.prepareSubmit': 'Close my shift',
    'shiftClosingReport.actions.createReport': 'Create report',
    'shiftClosingReport.actions.submit': 'Submit shift closing',
    'shiftClosingReport.actions.update': 'Update shift closing report',
    'shiftClosingReport.actions.approve': 'Approve',
    'shiftClosingReport.actions.reject': 'Reject',
    'shiftClosingReport.actions.cancel': 'Cancel',
    'shiftClosingReport.actions.confirmReject': 'Confirm rejection',
    'shiftClosingReport.actions.addRow': 'Add row',
    'shiftClosingReport.stats.invoiceCount': 'Invoices',
    'shiftClosingReport.stats.revenue': 'Revenue',
    'shiftClosingReport.stats.goods': 'Goods amount',
    'shiftClosingReport.stats.time': 'Time amount',
    'shiftClosingReport.stats.discount': 'Discount',
    'shiftClosingReport.stats.vat': 'Tax/VAT',
    'shiftClosingReport.stats.receipt': 'Receipts',
    'shiftClosingReport.stats.payment': 'Payments',
    'shiftClosingReport.stats.net': 'Cash-book net',
    'shiftClosingReport.stats.actualRevenue': 'System net revenue',
    'shiftClosingReport.stats.debt': 'Debt incurred',
    'shiftClosingReport.stats.actualTotal': 'Actual counted total',
    'shiftClosingReport.stats.formulaTitle': 'Calculation formula',
    'shiftClosingReport.stats.formula.invoiceCount':
      'Invoices = Number of completed invoices in the shift',
    'shiftClosingReport.stats.formula.revenue':
      'Revenue = Amount paid when each invoice was closed + Debt written on those invoices (debt collection excluded)',
    'shiftClosingReport.stats.formula.goods':
      'Goods amount = Product amount on invoices (excluding table time)',
    'shiftClosingReport.stats.formula.time': 'Time amount = Table time on invoices',
    'shiftClosingReport.stats.formula.discount':
      'Discount = Total invoice discounts + Redeemed point value',
    'shiftClosingReport.stats.formula.vat': 'Tax/VAT = Total VAT on the invoices',
    'shiftClosingReport.stats.formula.receipt': 'Receipts = Total amount of receipts in the shift',
    'shiftClosingReport.stats.formula.payment': 'Payments = Total amount of payments in the shift',
    'shiftClosingReport.stats.formula.actualRevenue':
      'System net revenue = Revenue + Receipts affecting profit/loss - Payments affecting profit/loss',
    'shiftClosingReport.stats.formula.debt':
      'Debt incurred = Invoice debt - Debt collected in shift (not below 0)',
    'shiftClosingReport.sections.reconciliation': 'Actual payment reconciliation',
    'shiftClosingReport.sections.saved': 'Submitted reports',
    'shiftClosingReport.sections.invoices': 'Invoices',
    'shiftClosingReport.sections.debtInvoices': 'Debt invoices',
    'shiftClosingReport.sections.receipts': 'Receipts',
    'shiftClosingReport.sections.payments': 'Payments',
    'shiftClosingReport.sections.paymentMethods': 'By payment method',
    'shiftClosingReport.sections.paymentMethodsHint': 'Total collected by each payment method',
    'shiftClosingReport.sections.revenueOverview': 'Revenue overview',
    'shiftClosingReport.sections.systemDetails': 'System details',
    'shiftClosingReport.fields.systemCash': 'System cash',
    'shiftClosingReport.fields.actualCash': 'Actual cash',
    'shiftClosingReport.fields.cashDifference': 'Cash difference',
    'shiftClosingReport.fields.systemTransfer': 'System transfer',
    'shiftClosingReport.fields.actualTransfer': 'Actual transfer',
    'shiftClosingReport.fields.transferDifference': 'Transfer difference',
    'shiftClosingReport.fields.note': 'Note/explanation',
    'shiftClosingReport.fields.reason': 'Reason',
    'shiftClosingReport.fields.startedAt': 'Start time',
    'shiftClosingReport.fields.endedAt': 'End time',
    'shiftClosingReport.fields.receptionist': 'Receptionist',
    'shiftClosingReport.fields.handoverTo': 'Handover recipient',
    'shiftClosingReport.fields.customer': 'Customer',
    'shiftClosingReport.fields.debtReason': 'Debt reason',
    'shiftClosingReport.fields.confirmer': 'Confirmer',
    'shiftClosingReport.fields.product': 'Product',
    'shiftClosingReport.fields.openingQuantity': 'Opening qty',
    'shiftClosingReport.fields.closingQuantity': 'Closing qty',
    'shiftClosingReport.fields.playingTables': 'Playing tables',
    'shiftClosingReport.fields.pendingTasks': 'Pending tasks',
    'shiftClosingReport.form.shiftInfo': 'Shift information',
    'shiftClosingReport.form.revenue': 'Revenue',
    'shiftClosingReport.form.payments': 'Payments',
    'shiftClosingReport.form.cash': 'Cash',
    'shiftClosingReport.form.debts': 'Debts',
    'shiftClosingReport.form.expenses': 'Shift expenses',
    'shiftClosingReport.form.inventory': 'Quick inventory',
    'shiftClosingReport.form.handover': 'Handover',
    'shiftClosingReport.form.systemValue': 'System value',
    'shiftClosingReport.form.actualValue': 'Actual value',
    'shiftClosingReport.form.differenceValue': 'Difference value',
    'shiftClosingReport.paymentBreakdown.show': 'Show cash-flow details',
    'shiftClosingReport.paymentBreakdown.hide': 'Hide cash-flow details',
    'shiftClosingReport.paymentBreakdown.sales': 'Sales and debt collection',
    'shiftClosingReport.paymentBreakdown.receipts': 'Receipts',
    'shiftClosingReport.paymentBreakdown.payments': 'Payments',
    'shiftClosingReport.paymentBreakdown.net': 'Net amount',
    'shiftClosingReport.metrics.sales': 'Total revenue',
    'shiftClosingReport.metrics.cash': 'Cash',
    'shiftClosingReport.metrics.transfer_qr': 'Transfer/QR',
    'shiftClosingReport.metrics.card': 'Card',
    'shiftClosingReport.metrics.e_wallet': 'E-wallet',
    'shiftClosingReport.metrics.debt': 'Debt/credit',
    'shiftClosingReport.metrics.opening': 'Opening cash',
    'shiftClosingReport.metrics.cash_sales': 'Cash sales revenue',
    'shiftClosingReport.metrics.shift_receipts': 'Shift receipts',
    'shiftClosingReport.metrics.expenses': 'Shift payments',
    'shiftClosingReport.metrics.closing': 'Closing cash',
    'shiftClosingReport.metrics.theoretical_closing': 'Theoretical closing cash',
    'shiftClosingReport.metrics.counted': 'Counted cash',
    'shiftClosingReport.metrics.difference': 'Difference',
    'shiftClosingReport.table.code': 'Code',
    'shiftClosingReport.table.date': 'Date',
    'shiftClosingReport.table.time': 'Time',
    'shiftClosingReport.table.customer': 'Customer/Entity',
    'shiftClosingReport.table.staff': 'Staff',
    'shiftClosingReport.table.type': 'Type',
    'shiftClosingReport.table.paymentMethod': 'Payment method',
    'shiftClosingReport.table.goods': 'Goods',
    'shiftClosingReport.table.timeAmount': 'Time',
    'shiftClosingReport.table.discount': 'Discount',
    'shiftClosingReport.table.vat': 'Tax/VAT',
    'shiftClosingReport.table.amount': 'Amount',
    'shiftClosingReport.table.total': 'Total',
    'shiftClosingReport.table.paidAmount': 'Paid',
    'shiftClosingReport.table.debtAmount': 'Outstanding debt',
    'shiftClosingReport.table.status': 'Status',
    'shiftClosingReport.table.actions': 'Actions',
    'shiftClosingReport.table.shift': 'Shift',
    'shiftClosingReport.table.approver': 'Approver',
    'shiftClosingReport.table.approvedAt': 'Approved at',
    'shiftClosingReport.table.rejector': 'Rejected by',
    'shiftClosingReport.table.rejectedAt': 'Rejected at',
    'shiftClosingReport.table.content': 'Description',
    'shiftClosingReport.table.money': 'Amount (₫)',
    'shiftClosingReport.status.draft': 'Not closed',
    'shiftClosingReport.status.submitted': 'Submitted',
    'shiftClosingReport.status.approved': 'Approved',
    'shiftClosingReport.status.rejected': 'Rejected',
    'shiftClosingReport.status.reopened': 'Reopened',
    'shiftClosingReport.warning.difference':
      'Actual payments differ from the system. Add an explanation before submitting.',
    'shiftClosingReport.validation.noteRequired': 'An explanation is required for a difference.',
    'shiftClosingReport.validation.reasonRequired': 'Enter a rejection reason.',
    'shiftClosingReport.messages.submitted': 'Shift closing report submitted.',
    'shiftClosingReport.messages.approved': 'Report approved.',
    'shiftClosingReport.messages.rejected': 'Report rejected.',
    'shiftClosingReport.errors.load': 'Unable to load shift closing report.',
    'shiftClosingReport.empty': 'No data in this period.',
    'shiftClosingReport.payments.cash': 'Cash',
    'shiftClosingReport.payments.card': 'Card',
    'shiftClosingReport.payments.transfer': 'Bank transfer',
    'shiftClosingReport.payments.bank_transfer': 'Bank transfer',
    'shiftClosingReport.payments.transfer_qr': 'Bank transfer/QR',
    'shiftClosingReport.payments.qr': 'QR code',
    'shiftClosingReport.payments.e_wallet': 'E-wallet',
    'shiftClosingReport.payments.wallet': 'E-wallet',
    'shiftClosingReport.payments.other': 'Other',
  },
}
